module.exports = __webpack_public_path__ + "pc/img/career-planner.d355d20e.webp";